module.exports = __webpack_public_path__ + "media/img/home/directions/list-12-1342fd603b6c095e1e0646918c653564.svg";